import * as React from 'react';
import LoadingAnimation from '../../components/LoadingAnimation';

const MessagesFeedLoader = () => (
    <div className="flexbox__column flexbox__column--loading">
        <LoadingAnimation />
    </div>
);

export default MessagesFeedLoader;



// WEBPACK FOOTER //
// ./src/sections/MessagesFeed/MessagesFeedLoader.tsx